import React from "react";
import HttpService from '../utils/Http.services';
import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";

import FixedView from "../components/FixedView";
import { widgetsList } from "../variables/widgetsList";
// import GaugeChart from 'react-gauge-chart'
import WidgetContainer from "../components/widgets/WidgetContainer";
import { nanoid } from "nanoid";
import DraggableList from "../components/dragLibrary/DraggableList";
import DraggableGrid from "../components/dragLibrary/DraggableGrid";
import LoaderButton from "../components/LoaderButton";
import { checkTextTranslation, imageAddress, translate } from "../utils/useful";
import PageStatusViewer from "../components/PageStatusViewer";
import ItemModal from "../modals/ItemModal";
import OptionsListModal from "../modals/OptionsListModal";
import RemoveConfirmationModal from "../modals/RemoveConfirmationModal";
import HttpServices from "../utils/Http.services";
import TLink from "../components/TLink";
import MultiSelectInput from "../components/inputs/MultiSelectInput";
import SidebarView from "../components/SidebarView";
import StagesManager from "../components/StagesManager";
import Slider from "react-slick";
import FirstStep from "./Applets/addwidgets/FirstStep";
import SecondStep from "./Applets/addwidgets/SecondStep";
import ThirdStep from "./Applets/addwidgets/ThirdStep";
import AddWidgets from "./Applets/addwidgets/AddWidgets";
import FourthStep from "./Applets/addwidgets/FourthStep";




class DashboardBuilder extends React.Component {


    state = {
        info: { modules: [] },
        data: [],
        page: {
            headers: [],
        },
        AllApplets: [],
        imageSlide: [

            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-1", size: 'small' },
            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-2", size: 'medium' },
            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-3", size: 'large' },

        ],
        singleWidgets: [

            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-1", size: 'small', description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.' },

        ],
        // widgetsList: [
        //     1, 1, 1, 1, 1
        // ]
    }

    componentDidMount() {
        let id
        // let id = this.props.match.params.id
        // console.log(id)
        // console.log(this.props.location?.state?.applet)
        // if (this.props.location?.state?.applet) {
        //     this.setState({ applet: this.props.location?.state?.applet })
        // }
        if (id) {
            setTimeout(() => {
                this.getDashboard(id)
            }, 10);
        } else {
            let info = this.state.info
            info.name = 'Dashboard Name'
            info.description = 'Dashboard description can be shown here'
            info.modules = []
            this.setState({ pageStatus: 200, info }, () => {
                this.setState({ show: true })
            })
        }
        this.getAllApplets()

        // setInterval(() => {
        //     console.log("TEST")
        //     console.log(this.addWidgetButton)
        // }, 2000);
    }

    getDashboard = (id) => {

        this.setState({ isLoading: true, show: true })

        HttpService.request("getDashboard", { id }, (fetchResult, fetchError, fetchStatus) => {
            this.setState({ isLoading: false })

            this.setState({ pageStatus: fetchStatus })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            console.log(fetchResult)
            this.setState({ info: fetchResult.info, applet: fetchResult.info.applet, roles: fetchResult.info.roles }, () => {
                console.log("SHOW")
                this.setState({ show: true })
            })

        })
    }



    postDashboard = () => {
        // console.log("POSTDASH")
        let info = this.state.info
        this.setState({ isLoadingPost: true })
        if (this.state?.applet) {
            info.applet = this.state?.applet
            info.roles = this.state.roles
        }

        HttpService.request("postDashboard", info, (fetchResult, fetchError) => {
            this.setState({ isLoadingPost: false })

            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            if (!info._id) {
                info._id = fetchResult.info._id
                this.setState({ info })
            }

            // console.log(fetchResult.info)
            // if (fetchResult.info) {
            //     this.setState({ info: fetchResult.info })
            // }
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })

        })

    }
    getAllApplets = () => {
        // console.log("POSTDASH")
        // let info = this.state.info
        // this.setState({ isLoadingPost: true })
        // if (this.state?.applet) {
        //     info.applet = this.state?.applet
        //     info.roles = this.state.roles
        // }

        HttpService.request("getMyApplets", {}, (fetchResult, fetchError) => {
            this.setState({ isLoadingPost: false })

            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }
            // if (!info._id) {
            //     info._id = fetchResult.info._id
            //     this.setState({ info })
            // }

            // console.log(fetchResult.info)
            // if (fetchResult.info) {
            // }
            this.setState({ AllApplets: fetchResult.info }, () => {
                console.log('this.state.AllApplets', this.state.AllApplets)
            })
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })

        })

    }


    addWidget = (widget) => {
        this.addWidgetFixedView.hideView()
        // let info = this.state.info
        let newWidget = JSON.parse(JSON.stringify(widget))
        newWidget.id = nanoid()

        let page = widgetsList[newWidget.key]


        this.setState({ currentItem: newWidget, page, currentIndex: -1 }, () => {
            this.itemModal.modal.showModal()
        })
        // this.openMore()
        // console.log(newWidget)
        // info.modules.push(newWidget)
        // this.setState({ info })
    }


    submitForm = (newData) => {
        let info = this.state.info
        let data = { ...newData }
        // let modules = this.state.info.modules

        this.handleFiles(data, () => {

            if (this.state.currentIndex == -1) {
                info.modules.push(data)
            } else {
                info.modules[this.state.currentIndex] = data
            }

            // console.log(modules)
            this.setState({ info }, () => {
                this.itemModal.modal.hideModal()
            })
        })

        // newWidget.id = nanoid()
        // info.modules.push(newWidget)
        // this.setState({ info })


    }

    handleFiles = (data, cb) => {
        console.log(data)

        HttpServices.handleFiles(null, data, () => {
            console.log(data)

            cb()
            // console.log("-------------")
            // console.log(data)
        })
    }



    updateData = (data, cb) => {
        //   console.log("UPDATE")
        //     console.log(data)
        this.setState({ data }, () => {
            if (cb) {
                cb()
            }
            if (this.props.updateData) {
                this.props.updateData(data)
            }
        })
    }



    changeValue = (key, value) => {
        let info = this.state.info
        info[key] = value
        this.setState({ info })
    }


    openMore = (prop, index) => {
        this.optionsModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index }, () => {
            // this.itemModal.modal.showModal()
        })
    }


    openEdit = () => {
        // console.log(this.state.currentItem)
        this.optionsModal.modal.hideModal()

        let page = widgetsList[this.state.currentItem.key]
        // console.log(page)
        this.setState({ page }, () => {
            this.itemModal.modal.showModal()
        })
    }


    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        // this.setState({ currentItem: prop, currentIndex: index })
    }

    doRemove = () => {

        let info = this.state.info
        info.modules.splice(this.state.currentIndex, 1)
        this.setState({ info }, () => {
            this.removeModal.modal.hideModal()
        })

    }

    changeStage = (key) => {
        if (this.stageManager) {
            this.stageManager.changeStage(key)
        }
    }

    setData = (data, cb) => {
        let newData = this.state.data
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }



    render() {

        if (this.state.show) {
            return (


                <div className="w-100 d-flex dashboardBuilder window-content-radius  h-100"  >
                    <div className="window-content-radius w-100 h-100 scroll-no-scrollbar ">
                        <div className="row m-0 px-3 py-2 flexcb" style={{ position: 'sticky', top: 0, backgroundImage: 'linear-gradient(#f6f6f6,#f2f2f2)', borderRadius: '0px 8px 0px 0px' }}>
                            <div className=" d-flex flex-column">
                                <input onChange={e => this.changeValue("name", e.target.value)} className="text-normal text-semibold " placeholder="Name ..." style={{ backgroundColor: 'transparent', border: 'none' }} value={this.state.info?.name}></input>
                                {/* <input onChange={e => this.changeValue("description", e.target.value)} className="text-small white opacity-7" placeholder="Description ..." style={{ backgroundColor: 'transparent', border: 'none' }} value={this.state.info?.description}></input> */}





                                {(this.state?.applet && this.state.roles) && (
                                    <div className="flexcb flex-wrap w-100">
                                        <div className='flexc px-1 mt-1 ' style={{ minWidth: 300, flex: 1 }}>
                                            <p className=" mrd-2 text-small">Roles</p>
                                            <div className="w-100 px-1 py-1" style={{ maxWidth: 300, backgroundColor: '#ffffffee', borderRadius: 4, minHeight: 35, position: 'relative', display: 'flex' }}>
                                                <MultiSelectInput changeValue={(key, value) => this.setState({ roles: value })} data={this.state.roles} header={{ information: { label: '{{lang}}applications', address: 'getGroups', filter: { applet: this.state?.applet }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}select', required: false } }} />
                                            </div>
                                        </div>
                                        <TLink to={"/applet/" + this.state?.applet?._id}><p className="white mrd-2 text-small px-1 mt-1">Applet: {this.state?.applet?.name}</p></TLink>

                                    </div>
                                )}
                            </div>

                            <div className=" flexc mt-2 mt-md-0 justify-content-md-end justify-content-center " style={{ display: 'flex' }}>


                                <button onClick={() => this.sidebarView.openSidebar()} className="px-2 py-2 mx-1" style={{ backgroundColor: '#ddd', borderRadius: 6 }}>
                                    <p className=" text-smaller text-semibold" style={{ whiteSpace: 'nowrap' }}>+ Add Widget</p>
                                </button>

                                {/* <button className="px-3 py-2" style={{ backgroundColor: '#fff', borderRadius: 20 }}>
                                        <p className=" text-small">Save</p>
                                    </button> */}

                                <div className="text-center text-small">

                                    <LoaderButton
                                        onClick={() => this.postTask()}
                                        isLoading={this.state.isLoading}
                                        text={translate("Save")}
                                        // disabled={!this.state.canContinue}
                                        background='linear-gradient(to right, #7064FE, #6473FE)'
                                        icon={'/assets/icons/useful/angle-right.svg'}
                                    />

                                    {/* <LoaderButton
                                        onClick={this.postDashboard}
                                        isLoading={this.state.isLoadingPost}
                                        text={translate("Save")}
                                        type={"Oval"}
                                        className=""
                                        buttonStyle={{ whiteSpace: 'nowrap', backgroundColor: '#fff', borderRadius: 20, outline: 'none', cursor: 'pointer', padding: '7px 30px', borderRadius: 30, fontSize: 15, border: 'none' }}
                                        width={40}
                                        height={40}
                                        color={'#fff'}
                                    /> */}
                                </div>


                            </div>

                        </div>
                        {/* images: [0: 'https://www.flaticon.com/svg/static/icons/svg/3799/3799967.svg'], */}

                        {/* <FixedView zIndex={10} ref={el => this.addWidgetFixedView = el} nodeRef={this.addWidgetButton}  > */}
                        {/* <div className="blur-back mld-0  flexcc flex-column" style={{ zIndex: 1, boxShadow: '0px 0px 15px #00000010', }}>
                            {/* <div className="py-2 px-2 w-100" style={{backgroundColor:'#e4e8f2',borderRadius:'4px 4px 0px 0px'}}>
                                    <p className="text-small tex-uppercase text-bold">Add Widget</p>
                                    </div> *
                            <div className="py-2 w-100" >
                                {Object.values(widgetsList).map((prop, index) => {
                                    return (
                                        <button key={index} className="w-100 px-2 flexc text-start" onClick={() => this.addWidget(prop)}>
                                            <div>
                                                <img src={prop.icon} width="40px" />
                                                <img src={prop?.images ? prop.images[0] : ''} width="40px" />
                                            </div>
                                            <div className="mld-4">
                                                <p className="text-normal text-bold">{prop.title}</p>
                                                <p className="text-smaller">this is the description of module</p>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>
                        </div> */}
                        {/* </FixedView> */}
                        <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} sideOpen={true} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >

                                <FirstStep stage={0} changeStage={this.changeStage} stageName={'applet'} initData={this.state.data} setData={this.setData} width={this.props.width} />
                                <SecondStep stage={1} changeStage={this.changeStage} stageName={'widgets'} initData={this.state.data} setData={this.setData} width={this.props.width} widgetsList={widgetsList} />
                                <ThirdStep stage={1} changeStage={this.changeStage} stageName={'thirdstep'} initData={this.state.data} setData={this.setData} width={this.props.width} />
                                <FourthStep stage={1} changeStage={this.changeStage} stageName={'fourthstep'} initData={this.state.data} setData={this.setData} width={this.props.width} />
                                <AddWidgets stage={1} changeStage={this.changeStage} stageName={'addwidgets'} initData={this.state.data} setData={this.setData} width={this.props.width} />
                                {/* <div stage={1} stageName={'widgets'} initData={this.state.data} setData={this.setData} width={this.props.width} className="w-100 h-100 scroll-no-scrollbar">

                                    <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                                        <div className="mb-2">
                                            <p style={{ color: '#fff' }}>
                                                Select Widgets
                                            </p>
                                        </div>
                                        <div >
                                            <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                                <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-100 mt-2 d-flex flex-wrap">
                                        {Object.values(widgetsList).map((prop, index) => {
                                            return (
                                                <button key={index} className="w-50 px-2 my-2 flex-column d-flex align-items-center text-start" onClick={() => this.addWidget(prop)}>
                                                    <div >
                                                        {/* <img src={prop.icon} width="40px" /> 
                                                        <img src={prop?.images ? prop.images[0] : ''} style={{ borderRadius: 11 }} width="120px" />
                                                    </div>
                                                    <div className="mld-4">
                                                        <p className="text-normal text-bold">{prop.title}</p>
                                                        {/* <p className="text-smaller">this is the description of module</p> *
                                                    </div>
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div> */}
                                {/* <div stage={1} stageName={'applets'} initData={this.state.data} setData={this.setData} width={this.props.width} className="w-100 h-100 scroll-no-scrollbar">

                                    <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                                        <div className="">
                                            <button onClick={() => this.props.lastStage()} className='flexc'>
                                                <div className='rotate-180 bg-dark-blue-1 br-50 ws-25 hs-25 flexcc'>
                                                    <img className='invert' src="/assets/icons/useful/angle-right.svg" height={20} />
                                                </div>
                                                <h2 style={{ color: '#ffffffcc' }} className=" text-big mb-0 mx-2" >{translate('Select Widgets')}</h2>
                                            </button>
                                        </div>
                                        {/* <div >
                                            <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                                <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                            </div>
                                        </div> *
                                    </div>
                                    <div className="w-100 mt-2 ">
                                        {this.state.imageSlide.map((prop) => {
                                            return (
                                                <div className="flexcc mb-4">
                                                    <div>
                                                        <div>
                                                            <img src={prop.img} style={{ borderRadius: 11 }} width='200px' />
                                                        </div>
                                                        <div className="flexcc flex-column">
                                                            <div>
                                                                <p style={{ fontSize: 14 }}>{prop.name}</p>
                                                            </div>
                                                            <div>
                                                                <p style={{ fontSize: 11 }}>{prop.size}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        <div>

                                        </div>
                                    </div>
                                </div> */}
                                {/* <div stage={1} stageName={'applets'} initData={this.state.data} setData={this.setData} width={this.props.width} className="w-100 h-100 scroll-no-scrollbar">

                                    <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                                        <div className="">
                                            <button onClick={() => this.props.lastStage()} className='flexc'>
                                                <div className='rotate-180 bg-dark-blue-1 br-50 ws-25 hs-25 flexcc'>
                                                    <img className='invert' src="/assets/icons/useful/angle-right.svg" height={20} />
                                                </div>
                                                <h2 style={{ color: '#ffffffcc' }} className=" text-big mb-0 mx-2" >{translate('Select Widgets')}</h2>
                                            </button>
                                        </div>
                                        {/* <div >
                                            <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                                <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                            </div>
                                        </div> *
                                    </div>
                                    <div className="w-100 mt-2 ">
                                        {this.state.singleWidgets.map((prop) => {
                                            return (
                                                <div className="flexcc mb-4 flex-column">
                                                    <div>
                                                        <div className="flexcc mt-2">
                                                            <img src={prop.img} style={{ borderRadius: 11 }} width='250px' />
                                                        </div>
                                                        <div className="flexcc flex-column">
                                                            <div>
                                                                <p className="mt-2" style={{ fontSize: 16, fontWeight: "600" }}>{prop.name}<span className="mld-3">{prop.size}</span></p>
                                                            </div>
                                                            {/* <div>
                                                                <p className="mt-2" style={{ fontSize: 11 }}>{prop.size}</p>
                                                            </div> 
                                                            <div>
                                                                <p className="mt-3 des-color text-center" style={{ fontSize: 13, maxWidth: "300px" }}>{prop.description}</p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <button className="flexcb mt-4 p-1" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', borderRadius: 9 }}>
                                                        <div className="mrd-1 default-btn-icon">
                                                            <p style={{ color: '#fff', padding: '3px 9px' }}>+</p>
                                                        </div>
                                                        <div className="px-3" style={{}}>
                                                            <p style={{ color: '#fff' }}>Add Widget</p>
                                                        </div>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div> */}
                            </StagesManager>
                        </SidebarView>




                        <div className="" style={{ padding: '20px 3% 20px 3%', backgroundColor: '#fff', minHeight: '95vh' }}>
                            <div className=" m-0">

                                <DraggableGrid dragstarted={this.dragStarted} dragover={this.dragOver} data={this.state.info?.modules} updatedata={this.updateData} width={400}>


                                    {this.state.info?.modules?.map((prop, index) => {
                                        if (prop) {
                                            let col = "col-lg-"
                                            if (prop.col) {
                                                col = col + prop.col
                                            } else {
                                                col = col + "4"
                                            }

                                            col = col + ' col-md-' + (prop.col <= 6 ? '6 ' : prop.col)
                                            col = col + ' col-' + (prop.col <= 3 ? '6 ' : '12 ')

                                            // console.log(prop.col)
                                            return (
                                                <WidgetContainer grid={prop.grid} id={prop.id} index={index} key={prop.id} data={prop} dashboard={this.state.info} isEditing={true} openMore={this.openMore} col={col} extraClass={'p-1'} />
                                            )
                                        }
                                    })}

                                </DraggableGrid>
                            </div>
                        </div>


                        <ItemModal
                            ref={el => this.itemModal = el}
                            page={this.state.page}
                            headers={this.state.page?.headers}
                            initData={this.state.currentItem}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemEdited}
                            submitForm={this.submitForm}
                            title={"Configure"}
                        />



                        <OptionsListModal ref={el => this.optionsModal = el}
                            options={[
                                // { name: 'View', icon: '/images/eye.svg', function: this.openView },
                                { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
                                { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
                            ]}
                        />

                        <RemoveConfirmationModal ref={el => this.removeModal = el} confirmed={this.doRemove} />
                    </div>

                </div>

            )
        } else {
            return (
                <div>
                    {/* <p>TEST</p> */}
                </div>
            )
        }
    }

}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardBuilder);
